<!-- 关于dnn -->
<template>
  <div class="about_dnn_container">
    <div class="wrapper">
      <footer class="aside-ft">
        <SamplePagination
          :total="3"
          :pageSize="1"
          theme="dark"
          :currentPage="currentPage"
          @current-change="handleCurrentChange"
        />
      </footer>
      <el-carousel
        indicator-position="none"
        :loop="true"
        :interval="8000"
        arrow="never"
        :autoplay="true"
        height="640px"
        ref="carouse"
        @change="handerChange"
      >
        <el-carousel-item v-for="(item, index) in dnnList" :key="index">
          <aside class="about-aside">
            <header
              class="aside-hd"
              v-scroll-animate="{ animation: 'fadeInUp' }"
            >
              {{ item.title }}
            </header>
            <p
              class="aside-bd"
              v-scroll-animate="{ animation: 'fadeInUp', delay: 200 }"
            >
              {{ item.summery }}
            </p>
            <span class="line"></span>
          </aside>
          <article class="about-mian">
            <img
              class="c_img cursor-pointer"
              :src="item.picUrl"
              alt="轮播图"
              @click="openUrl(item)"
            />
          </article>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import SamplePagination from "@/components/SamplePagination.vue";
import about_dnn_1 from "@/assets/images/homeImg/about_dnn_1.png";
import about_dnn_2 from "@/assets/images/homeImg/about_dnn_2.png";
import about_dnn_3 from "@/assets/images/homeImg/about_dnn_3.png";
export default {
  name: "Banner",
  components: { SamplePagination },
  data() {
    return {
      currentPage: 1,
      dnnList: [
        {
          id: 1,
          picUrl: about_dnn_1,
          linkUrl: "",
          title: "About Delauney",
          summery:
            "Jiangsu Delauney Information Technology Co., Ltd. was established in 2018. The company is dedicated to providing intelligent software products and solutions for the full lifecycle of infrastructure for engineers. Our products are applied in the infrastructure industry (particularly in transportation and urban construction) for planning, design, construction, and operation & maintenance across the entire lifecycle. Our products enhance work and collaboration efficiency, help clients accumulate valuable data assets, explore and activate data elements, and build digital twin models of infrastructure.",
        },
        {
          id: 2,
          picUrl: about_dnn_2,
          linkUrl: "",
          title: "About Delauney",
          summery:
            "With the large-scale development of highways and urban construction in China, Delauney's software products have over 20 years of history. We have obtained 15 invention patents and 39 software copyrights. Delauney's software products serve over a thousand client enterprises and more than 20,000 designer users. In recent years, we have helped clients complete road design schemes totaling 43,000 kilometers and over 1,000 interchanges. Delauney's intelligent construction products have been used in over 40 major infrastructure projects, providing BIM+GIS 3D visualization, collaborative management, schedule management, on-site inspection, quality control, intelligent safety supervision, electronic archives, and more for highways, large bridges, and tunnel projects.",
        },
        {
          id: 3,
          picUrl: about_dnn_3,
          linkUrl: "",
          title: "About Delauney",
          summery:
            "As a renowned brand in China's infrastructure digitalization, Delauney has three main product lines: digital design, intelligent construction, and digital twin. The design product line includes AlRoad (Road Engineering Schematic Design System), ElCAD (Integrated Road and Interchange Design System), VRRoad (Road Driving Simulation and Safety Evaluation System), Report 3D (3D Presentation System), Delivery 3D (Design Management System), and more. The construction product line includes the Digital Construction Management Platform, Digital Smart Site Platform, Industrialized Prefabrication Platform, and others. The Infrastructure Operation and Maintenance Digital Twin Solution includes Digital Twin Waterway Platform, Digital Highway Platform, and Digital Twin City Infrastructure Platform.",
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    /*
     * @Description: 打开链接
     * @MethodAuthor:  liulian
     * @Date: 2023-07-26 09:17:29
     * @param: ''
     */
    openUrl(item) {
      if (item.bannerLink) {
        window.open(item.bannerLink, "_blank");
      }
    },
    handerChange(index) {
      this.currentPage = index + 1;
    },
    handleCurrentChange({ pageIndex }) {
      console.log(`当前页: ${pageIndex}`);
      this.currentPage = pageIndex;
      this.$refs.carouse.setActiveItem(this.currentPage - 1);
    },
  },
};
</script>

<style lang="scss">
.about_dnn_container {
  padding: 80px 0;
  background: #fff;
  .wrapper {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    height: 640px;
    .el-carousel__arrow {
      display: none;
    }
    .el-carousel__item {
      display: flex;
    }
    .aside-ft {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      margin-top: 24px;
      height: 32px;
      background: #fff;
      z-index: 100;
      // .el-pagination button:disabled {
      //   color: #c0c4cc;
      //   background-color: #ffffff;
      //   cursor: not-allowed;
      // }
      // .page-info-tip {
      //   color: #333;
      // }
      // .el-pagination .btn-prev,
      // .el-pagination .btn-next {
      //   color: #333;
      // }
    }
    .about-aside {
      position: relative;
      flex: 1;
      padding-right: 60px;
      .aside-hd {
        margin-bottom: 24px;
        font-size: 32px;
        color: #333;
        line-height: 48px;
        text-align: left;
        font-style: normal;
      }
      .aside-bd {
        font-weight: 400;
        font-size: 18px;
        color: #333;
        line-height: 40px;
        text-align: justify;
        font-style: normal;
        height: calc(100% - 128px);
      }
      .line {
        position: absolute;
        right: 0;
        top: 0;
        width: 4px;
        height: 107px;
        background: #0074db;
      }
    }
    .about-mian {
      width: 560px;
      height: 640px;
      margin-left: 16px;
      img {
        width: auto;
        height: 640px;
        object-fit: contain;
      }
    }
  }
}
</style>
